module.exports = __webpack_public_path__ + "static/media/background3.452c010d.jpg";